import Rails from "@rails/ujs"
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['totalPoint', 'totalMedicalExpense', 'amountRequest', 'selfPaymentRate', 'fee0', 'fee1', 'fee2', 'fee3','form']
  static classes = []
  static values = {}

  connect() {
    this.calculateTotalPoint()
    this.calculateTotalExpense()
    this.calculateSelfPayment()
  }

  changeSelfPaymentRate() {
    this.calculateSelfPayment()
  }

  changeFeeItem() {
    this.calculateTotalPoint()
    this.calculateTotalExpense()
    this.calculateSelfPayment()
  }

  calculateTotalPoint() {
    const fee0 = parseInt(this.fee0Target.value)
    const fee1 = parseInt(this.fee1Target.value)
    const fee2 = parseInt(this.fee2Target.value)
    const fee3 = parseInt(this.fee3Target.value)
    this.totalPointTarget.textContent = fee0 + fee1 + fee2 + fee3
  }

  calculateTotalExpense() {
    this.totalMedicalExpenseTarget.textContent = parseInt(this.totalPointTarget.textContent) * 10
  }

  calculateSelfPayment() {
    const payment = parseInt(this.selfPaymentRateTarget.value) * parseInt(this.totalMedicalExpenseTarget.textContent) / 100
    this.amountRequestTarget.textContent = Math.round(payment / 10) * 10
  }

  buttonDisabled(event){
    const el = event.currentTarget;
    el.disabled = true;
    this.formTarget.submit();
  }

}
